module.exports = {
  footerText: 'Copyright Óptica Optica Simón Bolívar © 2021',
}
